const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/Components/RegristrationDialog/RegristrationDialogComponent.tsx';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, Typography } from '@mui/material';
import textMap from './translations';
import * as React from 'react';
import { useEffect } from 'react';
import { css } from '@emotion/css';
import { useDispatch, useSelector } from 'react-redux';
import { addToNotificationListRecords } from 'App/actions/notificationList';
import { actionLoadSignedTokenForIAM } from 'App/actions/iam';
import { getRedirectUrl } from 'App/utils/urlLocationCheck';
import { LoginData } from 'App/defs/loginDefs';
import { useIntl } from 'react-intl';
import { useFeatureFlags } from 'App/store/featureFlags';
import { useUserLinked } from 'App/store/userLinkage';
import { invitationCode } from 'App/store/login';
import { getTokenForIAMRoot } from 'App/store/iam';
import { RequestStatus } from '@cistec/common_web/utils/redux4Requests';

const dialogActionStyle = css`
    display: flex;
    gap: 10px;
`;

enum PatientLinkageDialogStatus {
    NONE = 'NONE',
    SKIPPED = 'SKIPPED',
    REGISTERD = 'REGISTERED',
}

export const PatientLinkageStatusLocalStorage = 'PatientLinkageStatus';

export const RegristrationDialogComponent = () => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch();
    const { data: featureFlags } = useFeatureFlags();
    const { data: patAppLinkStatus, status: requestStatus } = useUserLinked();
    const invitationCodeFromLogin = useSelector(invitationCode);

    const loginData = JSON.parse(sessionStorage.getItem(LoginData) as string);
    const loginType = loginData?.login_type;
    const iamToken: any = useSelector(getTokenForIAMRoot);

    useEffect(() => {
        if (featureFlags.dashboard.iamDialog && requestStatus === RequestStatus.SUCCESS) {
            if (patAppLinkStatus) {
                localStorage.setItem(PatientLinkageStatusLocalStorage, PatientLinkageDialogStatus.REGISTERD);
            } else {
                if (!localStorage.getItem(PatientLinkageStatusLocalStorage)) {
                    localStorage.setItem(PatientLinkageStatusLocalStorage, PatientLinkageDialogStatus.NONE);
                } else if (
                    localStorage.getItem(PatientLinkageStatusLocalStorage) === PatientLinkageDialogStatus.SKIPPED
                ) {
                    addRegristrationRequestToNotificationList();
                } else {
                    localStorage.setItem(PatientLinkageStatusLocalStorage, PatientLinkageDialogStatus.NONE);
                }
            }
        }
    }, [patAppLinkStatus, iamToken, featureFlags, requestStatus]);

    useEffect(() => {
        if (featureFlags.dashboard.iamDialog && invitationCodeFromLogin) {
            dispatch(actionLoadSignedTokenForIAM());
        }
    }, [invitationCodeFromLogin]);

    // FUNCTIONS
    const addRegristrationRequestToNotificationList = () => {
        if (iamToken) {
            dispatch(
                addToNotificationListRecords({
                    text: textMap.regristrationRequest,
                    actionText: textMap.regristrationButton,
                    routeTo: getRedirectUrl(iamToken),
                })
            );
        }
    };

    const handleRegristrationDialogSkip = () => {
        addRegristrationRequestToNotificationList();
        localStorage.setItem(PatientLinkageStatusLocalStorage, PatientLinkageDialogStatus.SKIPPED);
    };
    const handleRegristrationDialogAccept = () => {
        if (iamToken) {
            window.location.replace(getRedirectUrl(iamToken));
        }
    };
    const dialogOpen =
        (localStorage.getItem(PatientLinkageStatusLocalStorage) === PatientLinkageDialogStatus.NONE || false) &&
        loginType !== 'IAM';

    return (
        <Dialog open={dialogOpen}>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <Typography>{formatMessage(textMap.regristrationRequest)}</Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <div className={dialogActionStyle}>
                    <Button color="primary" variant="contained" onClick={handleRegristrationDialogAccept}>
                        {formatMessage(textMap.regristrationButton)}
                    </Button>
                    <Button color="primary" variant="text" onClick={handleRegristrationDialogSkip}>
                        {formatMessage(textMap.regristrationSkipButton)}
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
};
